import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  faIndustry,
  faPeopleCarry,
  faTruckRampBox,
  faBoxes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import StatisticsCard from "../uielements/StatisticsCard";
import Api from "../../helpers/apiHandler";
import countsActions from "../../redux/counts/actions";
import { newPermissionValue } from "../../helpers/constants";

const { updateCount } = countsActions;
const api = new Api();

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    `repeat(${Math.max(props.$columns || 1, 1)}, minmax(0, 1fr))`};
  gap: 20px;
  @media only screen and (max-width: 1024px) {
    grid-template-columns: ${(props) =>
      props.$columns > 2
        ? "repeat(2, minmax(0, 1fr))"
        : `repeat(${Math.max(props.$columns || 1, 1)}, minmax(0, 1fr))`};
  }
  @media only screen and (max-width: 640px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const SuppliersCount = ({
  onUpdateCount,
  counts,
  companyId,
  sideBarItems,
  ...props
}) => {
  const [count, setCount] = useState({});
  const [isManufacturers, setIsManufacturers] = useState(false);
  const [isCoPackers, setIsCoPackers] = useState(false);
  const [isSuppliers, setIsSuppliers] = useState(false);
  const [isPurchaseOrders, setIsPurchaseOrders] = useState(false);

  useEffect(() => {
    let manufacturersAccess = false;
    let coPackersAccess = false;
    let suppliersAccess = false;
    let purchaseOrdersAccess = false;

    if (sideBarItems && sideBarItems.length > 0) {
      sideBarItems.forEach((item) => {
        if (item.moduleName === "manufacturer") {
          manufacturersAccess =
            item.permissionId != newPermissionValue.noAccess;
        }
        if (item.moduleName === "copacker") {
          coPackersAccess = item.permissionId != newPermissionValue.noAccess;
        }
        if (item.moduleName === "supplier") {
          suppliersAccess = item.permissionId != newPermissionValue.noAccess;
        }
        if (item.moduleName === "orders") {
          purchaseOrdersAccess =
            item.permissionId != newPermissionValue.noAccess;
        }
      });
    }

    setIsManufacturers(manufacturersAccess);
    setIsCoPackers(coPackersAccess);
    setIsSuppliers(suppliersAccess);
    setIsPurchaseOrders(purchaseOrdersAccess);
  }, [sideBarItems]);

  useEffect(() => {
    if (companyId) {
      getCount();
    }
  }, [companyId]);

  useEffect(() => {
    if (counts) {
      setCount(counts);
    }
  }, [counts]);

  const getCount = () => {
    const payload = {
      companyId: companyId,
      menuType: "SUPPLIERS",
    };
    api
      .post("common/count", {
        isMultipart: false,
        data: payload,
      })
      .then((response) => {
        if (response.status === 1) {
          onUpdateCount({
            supplier: {
              manufacturers: response.data.manufacturer,
              suppliers: response.data.supplier,
              coPackers: response.data.coPacker,
            },
          });
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  const visibleColumns = [
    isManufacturers,
    isSuppliers,
    isCoPackers,
    isPurchaseOrders,
  ].filter(Boolean).length;

  return (
    <GridContainer className="width-100" $columns={visibleColumns || 1}>
      {isManufacturers && (
        <StatisticsCard
          title={"Manufacturers"}
          count={count.manufacturers || 0}
          icon={
            <FontAwesomeIcon
              icon={faIndustry}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#9D6AB0"}
          to="/manufacturer"
          onClick={() => props.history.push("/manufacturer")}
        />
      )}
      {isSuppliers && (
        <StatisticsCard
          title={"Suppliers"}
          count={count.suppliers || 0}
          icon={
            <FontAwesomeIcon
              icon={faPeopleCarry}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#8BBC27"}
          to="/supplier"
          onClick={() => props.history.push("/supplier")}
        />
      )}
      {isCoPackers && (
        <StatisticsCard
          title={"Co-Packers"}
          count={count.coPackers || 0}
          icon={
            <FontAwesomeIcon
              icon={faBoxes}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#E67E22"}
          to="/co-packer"
          onClick={() => props.history.push("/co-packer")}
        />
      )}
      {isPurchaseOrders && (
        <StatisticsCard
          title={"Outgoing Purchase Orders"}
          icon={
            <FontAwesomeIcon
              icon={faTruckRampBox}
              style={{
                height: "16px",
                width: "16px",
                color: "#fff",
              }}
            />
          }
          color={"#20CCE2"}
          showOnlyTitle
          to="/purchase-orders"
          onClick={() => props.history.push("/purchase-orders")}
        />
      )}
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  companyId: state.Auth.company.id,
  counts: state.Counts.supplier,
  sideBarItems: state.Auth.sideBarItems,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateCount: (data) => dispatch(updateCount(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SuppliersCount)
);
